export default (q='', callback=()=>{}) => {
    const mq = window.matchMedia( q );
    mq.addListener(callback);
    callback(mq);
    return mq;
}
